import Types from "../../action/types";

const defaultState = {
  work: "cut",
  uploading: false,
  uploadPercent: 0,
  processPercent: 0,
  processStep: 0,
  currProgress: null,
  startTime: {},
  cancelProgress: false,
  fileToBlobStatus: false,
  submitting: false,
  uploadXHR: null,
  fetchAbort: null,
  toGifObj: null,
  crop: null,
  audioCompressList: [],
  audioExtractorFile: null,
  audioJoinerList: [],
  audioCutSpeedVolumeObj: null,
  audioAddMusicList: [],
  videoCompressObj: null,
  videoMuteObj: null,
  imageCutoutObj: null,
};

export default function onAction(state = defaultState, action) {
  switch (action.type) {
    case Types.WORK_CHANGE:
      return {
        ...state,
        work: action.work,
      };
    case Types.UPLOADING_CHANGE:
      return {
        ...state,
        uploading: action.uploading,
      };
    case Types.UPLOADPERCENT_CHANGE:
      return {
        ...state,
        uploadPercent: action.uploadPercent,
      };
    case Types.PROCESSPERCENT_CHANGE:
      return {
        ...state,
        processPercent: action.processPercent,
      };
    case Types.PROGRESSSTEP_CHANGE:
      return {
        ...state,
        processStep: action.processStep,
      };
    case Types.CURRPROGRESS_CHANGE:
      return {
        ...state,
        currProgress: action.currProgress,
      };
    case Types.STARTTIME_CHANGE:
      return {
        ...state,
        startTime: action.startTime,
      };
    case Types.CANCELPROGRESS_CHANGE:
      return {
        ...state,
        cancelProgress: action.cancelProgress,
      };
    case Types.FILETOBLOBSTATUS_CHANGE:
      return {
        ...state,
        fileToBlobStatus: action.fileToBlobStatus,
      };
    case Types.SUBMITTING_CHANGE:
      return {
        ...state,
        submitting: action.submitting,
      };
    case Types.UPLOADXHR_CHANGE:
      return {
        ...state,
        uploadXHR: action.uploadXHR,
      };
    case Types.FETCHABORT_CHANGE:
      return {
        ...state,
        fetchAbort: action.fetchAbort,
      };
    case Types.TOGIFOBJ_CHANGE:
      return {
        ...state,
        toGifObj: action.toGifObj,
      };
    case Types.CROP_CHANGE:
      return {
        ...state,
        crop: action.crop,
      };
    case Types.AUDIOCOMPRESSLIST_CHANGE:
      return {
        ...state,
        audioCompressList: action.audioCompressList,
      };
    case Types.AUDIOEXTRACTORFILE_CHANGE:
      return {
        ...state,
        audioExtractorFile: action.audioExtractorFile,
      };
    case Types.AUDIOJOINERLIST_CHANGE:
      return {
        ...state,
        audioJoinerList: action.audioJoinerList,
      };
    case Types.AUDIOCUTSPEEDVOLUMEOBJ_CHANGE:
      return {
        ...state,
        audioCutSpeedVolumeObj: action.audioCutSpeedVolumeObj,
      };
    case Types.AUDIOADDMUSICLIST_CHANGE:
      return {
        ...state,
        audioAddMusicList: action.audioAddMusicList,
      };
    case Types.VIDEOCOMPRESSOBJ_CHANGE:
      return {
        ...state,
        videoCompressObj: action.videoCompressObj,
      };
    case Types.VIDEOMUTEOBJ_CHANGE:
      return {
        ...state,
        videoMuteObj: action.videoMuteObj,
      };
    case Types.IMAGECUTOUTOBJ_CHANGE:
      return {
        ...state,
        imageCutoutObj: action.imageCutoutObj,
      };
    default:
      return state;
  }
}
